module.exports = __webpack_public_path__ + "static/img/partner5.6147882.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/partner5.png
// module id = /Sd1
// module chunks = 0